/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { Strign } from './strign';

/**
 * 
 * @export
 * @interface UpdateMerchantOrgBlockListRequest
 */
export interface UpdateMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'acquirerId': string;
    /**
     * 
     * @type {Strign}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'patternType': UpdateMerchantOrgBlockListRequestPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'storeType': UpdateMerchantOrgBlockListRequestStoreTypeEnum;
}

export const UpdateMerchantOrgBlockListRequestPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantOrgBlockListRequestPatternTypeEnum = typeof UpdateMerchantOrgBlockListRequestPatternTypeEnum[keyof typeof UpdateMerchantOrgBlockListRequestPatternTypeEnum];
export const UpdateMerchantOrgBlockListRequestStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantOrgBlockListRequestStoreTypeEnum = typeof UpdateMerchantOrgBlockListRequestStoreTypeEnum[keyof typeof UpdateMerchantOrgBlockListRequestStoreTypeEnum];


